import * as Sentry from '@sentry/react'

import { LOCALES_WITHOUT_CLDR, type SupportedLocale } from './types'

type IntlProviderError = {
  code: string
  descriptor?: { id?: string }
}

/** Reports intl failures. Locales without CLDR accept English dates and numbers. */
export function reportIntlProviderError(err: IntlProviderError, locale: SupportedLocale): void {
  if (err.code === 'MISSING_DATA' && LOCALES_WITHOUT_CLDR.has(locale)) return
  if (err.code === 'MISSING_TRANSLATION') {
    Sentry.captureEvent({
      message: `Missing translation: ${err.descriptor?.id ?? 'unknown'}`,
      level: 'warning',
      tags: { feature: 'i18n', locale, 'translation.key': err.descriptor?.id ?? 'unknown' },
    })
    return
  }
  Sentry.captureException(err, { tags: { feature: 'i18n', locale } })
}
